import {Avatar, Button, Card, List, Pagination, Tag} from "antd";
import {FaMapMarkedAlt} from "react-icons/fa";
import {Link} from "react-router-dom";
import React from "react";

export const CandidateList = ({candidates}) => {
    return (
        <>
            <List
                itemLayout="vertical"
                dataSource={candidates}
                renderItem={item => (
                    <Card
                        to={`/profile/${item.id}`}
                        className="w-full lg:relative grid grid-cols-1 sm:grid-cols-2 items-center justify-between lg:p-4 mb-4 hover:cursor-pointer hover:border-primary-hover shadow-md border-gray-200">
                        <div className="flex flex-row items-center gap-4">
                            <Avatar src={item.avatar} size={64}/>
                            <div>
                                <h3 className="text-lg font-semibold">{item.name}</h3>
                                <p className="text-gray-500">{item.job}</p>
                                <div className="flex items-center gap-2">
                                    <FaMapMarkedAlt/>
                                    <span>{item.location}</span>
                                </div>
                            </div>
                        </div>
                        <Button className="lg:absolute lg:right-4 mt-4 lg:bottom-4 w-full sm:w-96 p-4 mx-auto border-green-500 shadow-md items-center">Xem chi tiết</Button>
                    </Card>
                )}
            />
            <Pagination className="mt-4 justify-center mx-auto" defaultCurrent={1} responsive total={50}/>
        </>

    );
}